/* ============================================================
   assets/dd-bugfix.js  —  bugsheet fixes, 15 Oct 2026
   Loaded (defer) from snippets/dd-custom-css.liquid.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Bug: clicking Search with an empty box ----
     dd-custom.js sends the browser to /pages/search?q= even when the box
     is empty, and the search page then spins forever. Intercept in the
     capture phase (runs before dd-custom.js's handlers), stay on the page,
     focus the box and show a prompt instead. */
  var HINT = 'Please type a product name to search';

  function nudge(input) {
    try {
      input.focus();
      input.classList.remove('dd-search-empty');
      void input.offsetWidth; // restart the CSS animation
      input.classList.add('dd-search-empty');
      if (!input.dataset.ddOrigPh) input.dataset.ddOrigPh = input.getAttribute('placeholder') || '';
      input.setAttribute('placeholder', HINT);
      clearTimeout(input.__ddHintTimer);
      input.__ddHintTimer = setTimeout(function () {
        input.classList.remove('dd-search-empty');
        if (input.getAttribute('placeholder') === HINT) {
          input.setAttribute('placeholder', input.dataset.ddOrigPh || '');
        }
      }, 2500);
    } catch (e) {}
  }

  function emptyInput() {
    var input = document.getElementById('ddHdInput');
    return input && !String(input.value || '').trim() ? input : null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#ddHdGo');
    if (!btn) return;
    var input = emptyInput();
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge(input);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || e.target.id !== 'ddHdInput') return;
    var input = emptyInput();
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge(input);
  }, true);

  /* ---- Bug: homepage FAQ opens the first question by default ----
     sections/dd-home-info.liquid hard-codes the first item as
     class="dd-faq-item is-open" + aria-expanded="true". Close it on load;
     the existing click toggle in dd-custom.js keeps working unchanged.
     (Permanent fix: remove " is-open" and set aria-expanded="false" on the
     first .dd-faq-item in sections/dd-home-info.liquid.) */
  function closeFirstFaq() {
    var list = document.getElementById('ddFaqList');
    if (!list) return;
    list.querySelectorAll('.dd-faq-item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var q = item.querySelector('.dd-faq-q');
      if (q) q.setAttribute('aria-expanded', 'false');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', closeFirstFaq);
  } else {
    closeFirstFaq();
  }
  document.addEventListener('shopify:section:load', closeFirstFaq);
})();
